import {
  CI_STATUS_LEGAL_RESIDENT,
  TAX_FILING_STATUS_DEPENDENT,
  TAX_FILING_STATUS_FILING_JOINTLY,
  WHO_SUPPORT_WITHOUT_INCOME_OTHER,
  WHO_SUPPORT_WITHOUT_INCOME_SELF,
} from 'components/EditPersonForm/schema'
import {getExtendedName} from './name'

export const isValidDueDate = (date: any) => {
  const today = new Date()
  const yearDiff = date?.getFullYear() - today.getFullYear()
  const monthDiff = date?.getMonth() - today.getMonth()
  const overallDiffInMonths = yearDiff * 12 + monthDiff
  // console.log({overallDiffInMonths})
  return overallDiffInMonths >= 0 && overallDiffInMonths <= 9
}

const isValidCharactors = (name: string) => {
  const nameRegex = /^[a-zA-Z ]*$/
  // console.log({name, isValid: nameRegex.test(name)})
  return nameRegex.test(name)
}

function hasValidSpace(name: string) {
  const excessiveSpacesRegex = /\s{2,}/ // Matches two or more consecutive spaces
  // const surroundingSpacesRegex = /^\s+|\s+$/ // Matches spaces at the beginning or end of the sentence

  const hasExcessiveSpaces = excessiveSpacesRegex.test(name?.trim())
  // const hasSurroundingSpaces = surroundingSpacesRegex.test(name)

  return !hasExcessiveSpaces //|| hasSurroundingSpaces
}

export const isValidInitialDateOfService = (initialDateOfService: any) => {
  const oneHour = 60 * 60 * 1000

  const diffHours: number = Math.round(
    (Date.now() - new Date(initialDateOfService).getTime()) / oneHour
  )
  // console.log({diffHours})
  return diffHours >= 0 && diffHours <= 144
}

export const getFullName = (person: any) =>
  `${person.firstName} ${
    person.middleName ? person.middleName.charAt(0).toUpperCase() : ''
  }${person.middleName ? ' ' : ''}${person.lastName}`

export const getHeadOfHouseholdParentOrLegalGuardian = (
  members: any[],
  application: any
) => {
  const relationships = application.person.relationships

  const memberPerson = members.map((member) => member.person)

  const femaleMembers = memberPerson
    .filter((member) => member.gender === 'Female')
    .map((member) => member.id)

  const femaleParentOrLegalGuardian = relationships.find(
    (relation: any) =>
      femaleMembers.indexOf(relation.otherPerson.id) >= 0 &&
      relation.relationshipType === 'Parent/legal guardian'
  )

  const maleMembers = memberPerson
    .filter((member) => member.gender === 'Male')
    .map((member) => member.id)

  const maleParentOrLegalGuardian = relationships.find(
    (relation: any) =>
      maleMembers.indexOf(relation.otherPerson.id) >= 0 &&
      relation.relationshipType === 'Parent/legal guardian'
  )
  return femaleParentOrLegalGuardian || maleParentOrLegalGuardian || null
}

export const getHouseholdMembersFromRelationships = (
  patient: any,
  application: any
) => {
  const _householdMembers: any = [
    {
      ...patient,
      person: {
        ...patient.person,
        initialDateOfService: application.initialDateOfService,
        isPatient: true,
        wantsPresumptiveEligibility: true,
        wantsNJFC: true,
        ciDocumentName:
          patient.person.ciDocumentName || getFullName(patient.person),
        taxFilerOfDependent: null,
        relationshipWithTaxFiler: null,
        filingJointly: null,
      },
    },
  ]

  application.person.relationships.forEach((relationship: any) => {
    const matchingRelationshipIndex = application.householdMembers.findIndex(
      (member: any) => relationship.otherPerson.id === member.person.id
    )
    const matchingHouseholdMember =
      application.householdMembers[matchingRelationshipIndex]

    if (matchingRelationshipIndex >= 0) {
      _householdMembers.push({
        id: matchingHouseholdMember.id,
        person: {
          ...relationship['otherPerson'],
          initialDateOfService: '',
          isPatient: false,
          wantsPresumptiveEligibility: false,
          wantsNJFC: relationship['otherPerson'].wantsCoverage ?? false,
          ciDocumentName:
            relationship['otherPerson'].ciDocumentName ||
            getFullName(relationship['otherPerson']),
          taxFilerOfDependent: null,
          relationshipWithTaxFiler: null,
          filingJointly: null,
        },
        createdAt: matchingHouseholdMember.createdAt,
        __typename: matchingHouseholdMember.__typename,
      })
    }
  })
  return _householdMembers
}
export const getAllRelationships = (patient: any, application: any) => {
  const _householdMembers: any = [
    {
      ...patient,
      person: {
        ...patient.person,
        initialDateOfService: application.initialDateOfService,
        isPatient: true,
        wantsPresumptiveEligibility: true,
        wantsNJFC: true,
        ciDocumentName:
          patient.person.ciDocumentName || getFullName(patient.person),
        taxFilerOfDependent: null,
        relationshipWithTaxFiler: null,
        filingJointly: null,
      },
    },
  ]

  application.person.relationships.forEach((relationship: any) => {
    const matchingRelationshipIndex = application.householdMembers.findIndex(
      (member: any) => relationship.otherPerson.id === member.person.id
    )
    const matchingHouseholdMember =
      application.householdMembers[matchingRelationshipIndex]

    if (matchingRelationshipIndex >= 0) {
      _householdMembers.push({
        id: matchingHouseholdMember.id,
        person: {
          ...relationship['otherPerson'],
          initialDateOfService: '',
          isPatient: false,
          wantsPresumptiveEligibility: false,
          wantsNJFC: relationship['otherPerson'].wantsCoverage ?? false,
          ciDocumentName:
            relationship['otherPerson'].ciDocumentName ||
            getFullName(relationship['otherPerson']),
          taxFilerOfDependent: null,
          relationshipWithTaxFiler: null,
          filingJointly: null,
        },
        createdAt: matchingHouseholdMember.createdAt,
        __typename: matchingHouseholdMember.__typename,
      })
    } else {
      _householdMembers.push({
        id: '1423',
        person: {
          ...relationship['otherPerson'],
          initialDateOfService: '',
          isPatient: false,
          wantsPresumptiveEligibility: false,
          wantsNJFC: relationship['otherPerson'].wantsCoverage ?? false,
          ciDocumentName:
            relationship['otherPerson'].ciDocumentName ||
            getFullName(relationship['otherPerson']),
          taxFilerOfDependent: null,
          relationshipWithTaxFiler: null,
          filingJointly: null,
        },
        createdAt: '2024-08-12T02:57:00Z',
        __typename: 'ApplicationHouseholdMember',
      })
    }
  })
  return _householdMembers
}

const requiredFields = {
  person: {
    id: null,
    homeAddressStreet: null,
    homeAddressCity: null,
    homeAddressZip: null,
    preferredLanguage: null,
    mailingAddressStreet: null,
    mailingAddressCity: null,
    mailingAddressState: null,
    mailingAddressZip: null,

    firstName: null,
    middleName: null,
    lastName: null,
    dob: null,
    maritalStatus: null,
    gender: null,
    pregnant: null,
    expectedChild: null,
    dueDate: null,
    relationships: [
      {
        id: null,
        relationshipType: null,
        reverseRelationshipType: null,
        otherPerson: {
          id: null,
        },
      },
    ],
    initialDateOfService: null,
    dateOfEntry: null,
    uscisNo: null,

    incomeSources: [
      {
        id: null,
        incomeType: null,
        employerName: null,
        fullPartTime: null,
        employerAddressStreet: null,
        employerAddressCity: null,
        employerAddressState: null,
        employerAddressZip: null,
        employerPhone: null,
        startMonth: null,
        startYear: null,
        payFrequency: null,
        amount: null,
      },
    ],
    taxFilingStatus: null,
    taxFilerOfDependent: null,
    relationshipWithTaxFiler: null,
    additionalComments: null,
    whoSupportWithoutIncome: null,
    selfSupportWithoutIncome: null,
    othersSupportWithoutIncome: null,
  },
  householdMembers: [
    {
      id: null,
      person: {
        id: null,
        firstName: null,
        middleName: null,
        lastName: null,
        dob: null,
        maritalStatus: null,
        gender: null,
        pregnant: null,
        expectedChild: null,
        dueDate: null,

        relationships: [
          {
            id: null,
            relationshipType: null,
            reverseRelationshipType: null,
            otherPerson: {
              id: null,
            },
          },
        ],

        initialDateOfService: null,
        dateOfEntry: null,
        uscisNo: null,

        incomeSources: [
          {
            id: null,
            incomeType: null,
            amount: null,
            employerName: null,
            fullPartTime: null,
            employerAddressStreet: null,
            employerAddressCity: null,
            employerAddressState: null,
            employerAddressZip: null,
            employerPhone: null,
            startMonth: null,
            startYear: null,
            payFrequency: null,
          },
        ],
        taxFilingStatus: null,
        taxFilerOfDependent: null,
        relationshipWithTaxFiler: null,
        whoSupportWithoutIncome: null,
        selfSupportWithoutIncome: null,
        othersSupportWithoutIncome: null,
      },
    },
  ],
  primaryPointOfContact: {
    firstName: null,
    middleName: null,
    lastName: null,
  },
  missingSpouseDetails: null,
  parentCount: null,
  missingHouseholdMember: null,
  allHouseholdMembers: [
    {
      person: {
        id: null,
        firstName: null,
        middleName: null,
        lastName: null,
        dob: null,
        maritalStatus: null,
        gender: null,
        pregnant: null,
        expectedChild: null,
        dueDate: null,
      },
    },
  ],
  allRelationships: [
    {
      from: null,
      to: null,
      relationship: null,
    },
  ],
}

export const cleanupFields = (obj: any): any => {
  if (
    !obj ||
    typeof obj !== 'object' ||
    (typeof obj === 'object' &&
      Object.prototype.toString.call(obj) === '[object Date]')
  ) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => cleanupFields(item))
  }

  const cleanObj = {...obj}
  const fieldsToRemove = ['createdAt', 'updatedAt', 'fieldsUpdatedAt']

  for (const key in cleanObj) {
    if (fieldsToRemove.includes(key)) {
      delete cleanObj[key]
    } else if (typeof cleanObj[key] === 'object') {
      cleanObj[key] = cleanupFields(cleanObj[key])
    }
  }

  return cleanObj
}

export const overrideFields = (
  obj: any,
  validate: boolean = true,
  mappedData: any
) => {
  let eligibleForSubmission = true
  function transform(
    key: string,
    parentObj: any,
    obj: any,
    requiredObj: any
  ): any {
    if (
      obj === null ||
      (typeof obj === 'object' &&
        Object.prototype.toString.call(obj) === '[object Date]') ||
      typeof obj !== 'object'
    ) {
      const isRequired =
        validate &&
        requiredObj !== undefined &&
        typeof obj !== 'boolean' &&
        getAdditionalConditionsChecked(key, parentObj)

      const optionalFieldsWithAdditionalValidationCheckRequired = [
        'prCardNo',
        'isStudent',
        'ciStatus',
      ]
      let validationCheck =
        isRequired ||
        optionalFieldsWithAdditionalValidationCheckRequired.indexOf(key) >= 0
          ? getAdditionalValidationChecked(obj, key, parentObj, mappedData)
          : {message: '', isValid: true}

      // console.log({
      //   key,
      //   isRequired,
      //   isValid: validationCheck.isValid,
      //   message: validationCheck.message,
      // })

      if (!validationCheck.isValid) {
        eligibleForSubmission = false
      }

      return {
        value: obj,
        required: isRequired,
        valid: validationCheck.isValid,
        message: validationCheck.message,
      }
    }

    // Recursive case: obj is an array or object
    if (Array.isArray(obj)) {
      return obj.map((item: any) =>
        transform(key, item, item, requiredObj ? requiredObj[0] : undefined)
      )
    }

    const transformedObj: any = {}
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        // Transform each field using the corresponding requiredObj key
        transformedObj[key] = transform(
          key,
          obj,
          obj[key],
          requiredObj ? requiredObj[key] : undefined
        )
      }
    }
    return transformedObj
  }

  return {
    modifiedApplication: transform('', obj, obj, requiredFields),
    eligibleForSubmission,
  }
}
const getAdditionalValidationChecked = (
  val: any,
  key: string,
  obj: any,
  mappedData: any
) => {
  const {_householdMembers, _allHouseholdMembers} = mappedData
  switch (key) {
    case 'firstName':
      return !obj['firstName']
        ? {message: '', isValid: false}
        : !isValidCharactors(obj['firstName'])
        ? {
            message:
              'Invalid characters detected. Please use only allowed characters.',
            isValid: false,
          }
        : !hasValidSpace(obj['firstName'])
        ? {
            message:
              'Extra spaces found. Ensure proper formatting without unnecessary spaces.',
            isValid: false,
          }
        : {message: '', isValid: true}

    case 'middleName':
      return obj['middleName']
        ? !isValidCharactors(obj['middleName'])
          ? {
              message:
                'Invalid characters detected. Please use only allowed characters.',
              isValid: false,
            }
          : !hasValidSpace(obj['middleName'])
          ? {
              message:
                'Extra spaces found. Ensure proper formatting without unnecessary spaces.',
              isValid: false,
            }
          : {message: '', isValid: true}
        : {message: '', isValid: true}

    case 'lastName':
      return !obj['lastName']
        ? {message: '', isValid: false}
        : !isValidCharactors(obj['lastName'])
        ? {
            message:
              'Invalid characters detected. Please use only allowed characters.',
            isValid: false,
          }
        : !hasValidSpace(obj['lastName'])
        ? {
            message:
              'Extra spaces found. Ensure proper formatting without unnecessary spaces.',
            isValid: false,
          }
        : {message: '', isValid: true}

    case 'dueDate':
      return {
        message:
          'Due date must not be in the past or exceed 9 months from today.',
        isValid: isValidDueDate(obj['dueDate']),
      }
    case 'initialDateOfService':
      return {
        message:
          'Date of Service (DOS) must be within the last 5 days (excluding today) and cannot be in the future.',
        isValid: isValidInitialDateOfService(obj['initialDateOfService']),
      }
    case 'uscisNo':
      return {
        message: 'Allowed format: 8 to 9 alphanumeric characters only.',
        isValid: obj['uscisNo']?.length > 7 && obj['uscisNo']?.length < 10,
      }
    case 'missingSpouseDetails':
      const marriedMemberCount = _householdMembers.filter(
        (member: any) =>
          member?.person?.maritalStatus?.toLowerCase() === 'married'
      ).length
      return {
        message:
          'Spouse details are missing. The number of married household members must be even.',
        isValid: marriedMemberCount % 2 === 0,
      }
    case 'parentCount':
      const patient = obj?.person
      const parentCount =
        patient.relationships.filter(
          (relation: any) =>
            relation.relationshipType === 'Parent/legal guardian'
        ).length ?? 0
      return {
        message: 'A maximum of 2 parents can be added.',
        isValid: parentCount <= 2,
      }
    case 'taxFilingStatus':
      const _joinFilerCount = _householdMembers.filter(
        (member: any) =>
          member?.person?.taxFilingStatus === TAX_FILING_STATUS_FILING_JOINTLY
      ).length
      if (obj['taxFilingStatus'] === TAX_FILING_STATUS_FILING_JOINTLY) {
        return {
          message:
            'A joint-filer is required. Please provide the necessary details.',
          isValid: _joinFilerCount % 2 === 0,
        }
      }
      return {message: '', isValid: true}
    case 'whoSupportWithoutIncome':
      const withIncome =
        _householdMembers.filter(
          (member: any) => member.person?.['incomeSources']?.length > 0
        ).length > 0
      const withSupportDetails =
        _householdMembers.filter(
          (member: any) => member.person?.['whoSupportWithoutIncome']
        ).length > 0
      if (
        withIncome ||
        (!withIncome &&
          obj['taxFilingStatus'] === TAX_FILING_STATUS_DEPENDENT) ||
        withSupportDetails
      ) {
        return {message: '', isValid: true}
      }
      return {
        message:
          'Who supports you when you don’t have income? Please provide details.',
        isValid: false,
      }
    case 'selfSupportWithoutIncome':
      const withIncome2 =
        _householdMembers.filter(
          (member: any) => member.person?.['incomeSources']?.length > 0
        ).length > 0
      const withSupportDetails2 =
        _householdMembers.filter(
          (member: any) =>
            member.person?.['whoSupportWithoutIncome'] &&
            (member.person?.['whoSupportWithoutIncome'] !==
              WHO_SUPPORT_WITHOUT_INCOME_SELF ||
              (member.person?.['whoSupportWithoutIncome'] ===
                WHO_SUPPORT_WITHOUT_INCOME_SELF &&
                member.person?.['selfSupportWithoutIncome']))
        ).length > 0
      if (
        withIncome2 ||
        (!withIncome2 &&
          obj['taxFilingStatus'] === TAX_FILING_STATUS_DEPENDENT) ||
        withSupportDetails2
      ) {
        return {message: '', isValid: true}
      }
      return {
        message: 'Explain how you are supporting yourself without any income.',
        isValid: false,
      }
    case 'othersSupportWithoutIncome':
      const withIncome3 =
        _householdMembers.filter(
          (member: any) => member.person?.['incomeSources']?.length > 0
        ).length > 0
      const withSupportDetails3 =
        _householdMembers.filter(
          (member: any) =>
            member.person?.['whoSupportWithoutIncome'] &&
            (member.person?.['whoSupportWithoutIncome'] !==
              WHO_SUPPORT_WITHOUT_INCOME_OTHER ||
              (member.person?.['whoSupportWithoutIncome'] ===
                WHO_SUPPORT_WITHOUT_INCOME_OTHER &&
                member.person?.['othersSupportWithoutIncome']))
        ).length > 0
      if (
        withIncome3 ||
        (!withIncome3 &&
          obj['taxFilingStatus'] === TAX_FILING_STATUS_DEPENDENT) ||
        withSupportDetails3
      ) {
        return {message: '', isValid: true}
      }
      return {
        message: 'Provide the full name and relationship of your supporter.',
        isValid: false,
      }

    case 'additionalComments':
      const householdMembersWithIncome = _householdMembers.filter(
        (member: any) => member.person?.['incomeSources']?.length > 0
      )
      const householdMembersWithSupportDetails = _householdMembers.filter(
        (member: any) =>
          member?.person?.whoSupportWithoutIncome &&
          ((member?.person?.whoSupportWithoutIncome ===
            WHO_SUPPORT_WITHOUT_INCOME_SELF &&
            member?.person?.selfSupportWithoutIncome) ||
            (member?.person?.whoSupportWithoutIncome ===
              WHO_SUPPORT_WITHOUT_INCOME_OTHER &&
              member?.person?.othersSupportWithoutIncome))
      )

      const isValidHouseholdMembersWithSupportDetails =
        householdMembersWithIncome.length > 0 ||
        (householdMembersWithIncome.length === 0 &&
          householdMembersWithSupportDetails.length > 0)

      return {
        message:
          'No member with income found. Please add either income details or supporter details.',
        isValid: isValidHouseholdMembersWithSupportDetails,
      }
    case 'dob':
      return {
        message: 'Date of Birth (DOB) cannot be in the future.',
        isValid: obj['dob'] && obj['dob'] < new Date(),
      }
    case 'dateOfEntry':
      return {
        message:
          'Date of Entry must be after the Date of Birth and cannot be in the future.',
        isValid:
          obj['dateOfEntry'] &&
          obj['dateOfEntry'] <= new Date() &&
          obj['dateOfEntry'] > obj['dob'],
      }
    case 'prCardNo':
      const regex = /^[A-Z]{3}\d{10}$/
      return {
        message:
          'Required format: ABC1234567890. Please follow the specified pattern.',
        isValid:
          obj['prCardNo'] && obj['prCardNo'].length > 0
            ? regex.test(obj['prCardNo'])
            : true,
      }
    case 'isStudent':
      if (obj['dob'] && obj['dob'] instanceof Date) {
        const today = new Date()
        let age = today.getFullYear() - obj['dob'].getFullYear()

        return {
          message: 'Full-time student is required.',
          isValid: age < 21 && obj['isStudent'] === null ? false : true,
        }
      } else {
        return {
          message: 'DOB is required.',
          isValid: false,
        }
      }
    case 'ciStatus':
      return {
        message: 'CI Status is required.',
        isValid: obj['ciStatus'] == null ? false : true,
      }

    case 'missingHouseholdMember':
      const _missingHouseholdMember =
        _householdMembers &&
        _allHouseholdMembers &&
        Array.isArray(_householdMembers) &&
        Array.isArray(_allHouseholdMembers) &&
        _householdMembers.length !== _allHouseholdMembers.length

      const missingMemberNames: Array<string> = []
      if (_missingHouseholdMember) {
        _allHouseholdMembers.forEach((member: any) => {
          const found = _householdMembers.find(
            (householdMember: any) =>
              householdMember.person.id === member.person.id
          )
          if (!found) {
            missingMemberNames.push(getFullName(member.person))
          }
        })
      }

      return {
        message: `Missing member(s): ${missingMemberNames.join(', ')}.`,
        isValid: !_missingHouseholdMember,
      }
    default:
      return {
        message: '',
        isValid: val !== null && val !== undefined && val !== '',
      }
  }
}
const getAdditionalConditionsChecked = (key: string, obj: any) => {
  switch (key) {
    case 'mailingAddressStreet':
      return obj['mailingAddressCity'] ||
        obj['mailingAddressState'] ||
        obj['mailingAddressZip']
        ? true
        : false
    case 'mailingAddressCity':
      return obj['mailingAddressStreet'] ||
        obj['mailingAddressState'] ||
        obj['mailingAddressZip']
        ? true
        : false
    case 'mailingAddressState':
      return obj['mailingAddressStreet'] ||
        obj['mailingAddressCity'] ||
        obj['mailingAddressZip']
        ? true
        : false
    case 'mailingAddressZip':
      return obj['mailingAddressStreet'] ||
        obj['mailingAddressCity'] ||
        obj['mailingAddressState']
        ? true
        : false
    case 'pregnant':
      return obj['gender'] === 'Female'
    case 'expectedChild':
      return obj['gender'] === 'Female' && obj['pregnant']
    case 'dueDate':
      return obj['gender'] === 'Female' && obj['pregnant']
    case 'employerName':
    case 'fullPartTime':
    case 'startMonth':
    case 'startYear':
      return (
        obj['incomeType'] === 'Salary/Wages (has paystub)' ||
        obj['incomeType'] === 'Freelance/Paid Cash' ||
        obj['incomeType'] === 'Self employed/Business owner'
      )
    case 'employerAddressStreet':
    case 'employerAddressCity':
    case 'employerAddressState':
    case 'employerAddressZip':
    case 'employerPhone':
      return obj['employerInsurance']
    case 'dateOfEntry':
      return obj['ciStatus'] === CI_STATUS_LEGAL_RESIDENT
    case 'initialDateOfService':
      return obj['isPatient']
    case 'uscisNo':
      return obj['ciStatus'] === CI_STATUS_LEGAL_RESIDENT && obj['uscisNo']
    case 'taxFilerOfDependent':
    case 'relationshipWithTaxFiler':
      return (
        obj['taxFilingStatus'] &&
        obj['taxFilingStatus'] === TAX_FILING_STATUS_DEPENDENT &&
        !obj['dependentOfTaxFilerId']
      )
    default:
      return true
  }
}

/* Capturing derived relationships. */
export const getAllRelationshipDetails = (patient: any, application: any) => {
  const _relationshipDetails: any = []
  application.person.relationships.forEach((relation: any) => {
    _relationshipDetails.push({
      from: `${relation.otherPerson?.firstName} ${relation.otherPerson?.lastName}`,
      to: `${patient.person?.firstName} ${patient.person?.lastName}`,
      relationship: relation.relationshipType,
      // reverseRelationship: relation.reverseRelationshipType,
    })
  })
  const otherRelationshipDetails: any[] = []
  for (let i = 0; i < _relationshipDetails.length; i++) {
    for (let j = i + 1; j < _relationshipDetails.length; j++) {
      const houseHold1 = _relationshipDetails[i]
      const houseHold2 = _relationshipDetails[j]
      if (
        !otherRelationshipDetails.find(
          (otherRelation) =>
            otherRelation.from === houseHold1.from &&
            otherRelation.to === houseHold2.from
        )
      ) {
        otherRelationshipDetails.push({
          from: houseHold1.from,
          to: houseHold2.from,
          ...evaluateRelation(
            houseHold1.from,
            houseHold2.from,
            _relationshipDetails
          ),
        })
      }
    }
  }
  return [..._relationshipDetails, ...otherRelationshipDetails]
}

function evaluateRelation(
  houseHold1: any,
  houseHold2: any,
  relationships: any
) {
  const relationship1WithPatient =
    relationships.find((relation: any) => relation.from === houseHold1)
      ?.relationship || ''
  const relationship2WithPatient =
    relationships.find((relation: any) => relation.from === houseHold2)
      ?.relationship || ''
  return evaluateDerivedRelationship(
    relationship1WithPatient,
    relationship2WithPatient
  )
}

export function evaluateDerivedRelationship(
  relationship1WithPatient: string,
  relationship2WithPatient: string,
  reverseEvaluation: boolean = false
) {
  if (
    relationship1WithPatient === 'Spouse' &&
    (relationship2WithPatient === 'Child' ||
      relationship2WithPatient === 'Stepchild' ||
      relationship2WithPatient === 'Nephew/niece')
  ) {
    return {
      relationship: 'Parent/legal guardian',
      reverse_relationship_type: relationship2WithPatient,
    }
  } else if (
    (relationship1WithPatient === 'Child' ||
      relationship1WithPatient === 'Stepchild' ||
      relationship1WithPatient === 'Nephew/niece') &&
    relationship2WithPatient === 'Spouse'
  ) {
    return {
      relationship: relationship1WithPatient,
      reverse_relationship_type: 'Parent/legal guardian',
    }
  } else if (
    (relationship1WithPatient === 'Child' ||
      relationship1WithPatient === 'Stepchild' ||
      relationship1WithPatient === 'Nephew/niece' ||
      relationship1WithPatient === 'Sibling/step-sibling') &&
    (relationship2WithPatient === 'Child' ||
      relationship2WithPatient === 'Stepchild' ||
      relationship2WithPatient === 'Nephew/niece' ||
      relationship2WithPatient === 'Sibling/step-sibling')
  ) {
    return {
      relationship: 'Sibling/step-sibling',
      reverse_relationship_type: 'Sibling/step-sibling',
    }
  } else if (
    relationship1WithPatient === 'Stepparent' &&
    relationship2WithPatient === 'Sibling/step-sibling'
  ) {
    return {
      relationship: 'Stepparent',
      reverse_relationship_type: 'Child',
    }
  } else if (
    relationship1WithPatient === 'Parent/legal guardian' &&
    relationship2WithPatient === 'Sibling/step-sibling'
  ) {
    return {
      relationship: 'Parent/legal guardian',
      reverse_relationship_type: 'Child',
    }
  } else if (
    relationship1WithPatient === 'Parent/legal guardian' &&
    relationship2WithPatient === 'Cousin'
  ) {
    return {
      relationship: 'Parent/legal guardian',
      reverse_relationship_type: 'Nephew/niece',
    }
  } else if (
    relationship1WithPatient === 'Parent/legal guardian' &&
    relationship2WithPatient === 'Stepparent'
  ) {
    return {
      relationship: 'Spouse',
      reverse_relationship_type: 'Spouse',
    }
  } else if (
    relationship1WithPatient === 'Parent/legal guardian' &&
    relationship2WithPatient === 'Parent/legal guardian'
  ) {
    return {
      relationship: 'Spouse',
      reverse_relationship_type: 'Spouse',
    }
  }
  if (!reverseEvaluation) {
    const {
      relationship,
      reverse_relationship_type,
    }: any = evaluateDerivedRelationship(
      relationship2WithPatient,
      relationship1WithPatient,
      true
    )
    if (relationship !== '') {
      return {
        // swapping relationship for opposite caltulation
        relationship: reverse_relationship_type,
        reverse_relationship_type: relationship,
      }
    }
  }
  return {
    relationship: '',
    reverse_relationship_type: '',
  }
}

export function evaluateDerivedRelationshipForTaxFiler(
  relationship1WithPatient: string,
  relationship2WithPatient: string,
  reverseEvaluation: boolean = false
) {
  if (
    relationship1WithPatient === 'Spouse' &&
    (relationship2WithPatient === 'Child' ||
      relationship2WithPatient === 'Stepchild' ||
      relationship2WithPatient === 'Nephew/niece')
  ) {
    return {
      relationship: 'Parent/legal guardian',
      reverse_relationship_type: relationship2WithPatient,
    }
  } else if (
    (relationship1WithPatient === 'Child' ||
      relationship1WithPatient === 'Stepchild' ||
      relationship1WithPatient === 'Nephew/niece') &&
    relationship2WithPatient === 'Spouse'
  ) {
    return {
      relationship: relationship1WithPatient,
      reverse_relationship_type: 'Parent/legal guardian',
    }
  } else if (
    (relationship1WithPatient === 'Child' ||
      relationship1WithPatient === 'Stepchild' ||
      relationship1WithPatient === 'Nephew/niece' ||
      relationship1WithPatient === 'Sibling/step-sibling') &&
    (relationship2WithPatient === 'Child' ||
      relationship2WithPatient === 'Stepchild' ||
      relationship2WithPatient === 'Nephew/niece' ||
      relationship2WithPatient === 'Sibling/step-sibling')
  ) {
    return {
      relationship: 'Sibling/step-sibling',
      reverse_relationship_type: 'Sibling/step-sibling',
    }
  } else if (
    relationship1WithPatient === 'Stepparent' &&
    relationship2WithPatient === 'Sibling/step-sibling'
  ) {
    return {
      relationship: 'Stepparent',
      reverse_relationship_type: 'Child/Stepchild',
    }
  } else if (
    relationship1WithPatient === 'Parent/legal guardian' &&
    relationship2WithPatient === 'Sibling/step-sibling'
  ) {
    return {
      relationship: 'Parent/legal guardian',
      reverse_relationship_type: 'Child/Stepchild',
    }
  } else if (
    relationship1WithPatient === 'Parent/legal guardian' &&
    relationship2WithPatient === 'Cousin'
  ) {
    return {
      relationship: 'Parent/legal guardian',
      reverse_relationship_type: 'Nephew/niece',
    }
  } else if (
    relationship1WithPatient === 'Parent/legal guardian' &&
    relationship2WithPatient === 'Stepparent'
  ) {
    return {
      relationship: 'Spouse',
      reverse_relationship_type: 'Spouse',
    }
  } else if (
    relationship1WithPatient === 'Parent/legal guardian' &&
    relationship2WithPatient === 'Parent/legal guardian'
  ) {
    return {
      relationship: 'Spouse',
      reverse_relationship_type: 'Spouse',
    }
  }
  if (!reverseEvaluation) {
    const {
      relationship,
      reverse_relationship_type,
    }: any = evaluateDerivedRelationshipForTaxFiler(
      relationship2WithPatient,
      relationship1WithPatient,
      true
    )
    if (relationship !== '') {
      return {
        // swapping relationship for opposite caltulation
        relationship: reverse_relationship_type,
        reverse_relationship_type: relationship,
      }
    }
  }
  return {
    relationship: '',
    reverse_relationship_type: '',
  }
}

export const getAdditionalComments = (
  t: any,
  householdMembersWithIncome: any,
  householdMembersWithSupportDetails: any
) => {
  let comment = ''
  if (householdMembersWithIncome && householdMembersWithIncome.length === 0) {
    if (
      householdMembersWithSupportDetails &&
      householdMembersWithSupportDetails.length > 0
    ) {
      let _comment = ''
      householdMembersWithSupportDetails.forEach(
        ({person: householdMember}: {person: any}) => {
          if (
            householdMember?.whoSupportWithoutIncome?.value &&
            householdMember?.whoSupportWithoutIncome?.value ===
              WHO_SUPPORT_WITHOUT_INCOME_SELF &&
            householdMember?.selfSupportWithoutIncome?.value
          ) {
            _comment = `${getExtendedName({
              ...{
                firstName: householdMember?.firstName.value,
                lastName: householdMember?.lastName.value,
                preferredName: '',
                middleName: householdMember?.middleName.value,
                suffix: '',
              },
              t,
            })} has no income in the last 30 days and is currently supporting him/herself. Explanation: ${
              householdMember?.selfSupportWithoutIncome?.value
            }.`
          }
          if (
            householdMember?.whoSupportWithoutIncome?.value &&
            householdMember?.whoSupportWithoutIncome?.value ===
              WHO_SUPPORT_WITHOUT_INCOME_OTHER &&
            householdMember?.othersSupportWithoutIncome?.value
          ) {
            _comment = `${getExtendedName({
              ...{
                firstName: householdMember?.firstName.value,
                lastName: householdMember?.lastName.value,
                preferredName: '',
                middleName: householdMember?.middleName.value,
                suffix: '',
              },
              t,
            })} has no income in last 30 days and is supported by 
              ${householdMember?.othersSupportWithoutIncome?.value} 
              ${
                householdMember?.supporterRelationship?.value
                  ? `(Relation: ${householdMember?.supporterRelationship?.value}).`
                  : ''
              }`
          }
          // console.log({_comment})
          let newComment = ''
          if (comment) {
            newComment = comment.concat(` `).concat(_comment)
          } else {
            newComment = comment.concat(_comment)
          }
          // console.log({length: newComment.length})
          if (newComment.length <= 250) {
            // Allowed max length for additional comment is 250 on NJ Portal
            comment = newComment // If the comment does not exceed 250 characters, update the comment
          } else {
            return comment // If the comment exceeds 250 characters, return the current comment
          }
        }
      )
    } else {
      comment = ''
    }
  } else {
    comment = 'No comments'
  }
  return comment
}
